import axios from 'axios'
import router from '@/router'

export default {
  namespaced: true,
  state: {
    me: null,
    profile: null
  },
  getters: {
    getMe(state){ return state.me },
    hasActiveSubscription(state) {
      /* ===== SUBSCRIPTION_FEATURE_START ===== */
      // Original subscription check code - temporarily disabled
      // if (!state.me) return false;
      // // Admin users don't need subscription
      // if (state.me.company_type === 'admin') return true;
      // // Check if subscription exists and is active
      // if (!state.me.subscription) return false;
      // const status = state.me.subscription.stripe_status || state.me.subscription.status;
      // return status === 'active' || status === 'trialing';
      /* ===== SUBSCRIPTION_FEATURE_END ===== */

      // Free access for all users
      return true;
    }
  },
  mutations: {
    setMe(state, data) {
      state.me = data.me
      state.profile = data.profile
    }
  },
  actions: {
    fetch({commit}) {
      return new Promise(async (resolve, reject) => {
  
        try {
          let r = router.history.current.name
          let response = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/api/users/profile`, {
            headers: {
              'Authorization': 'Bearer ' + (this.getters['auth/jwt'] || this.getters['auth/accessToken'] || localStorage.getItem('auth_token'))
            }
          })

          if (response.status == 200) {
             commit('setMe', {
              me: response.data, 
              profile: response.data
            });
            // commit('setMe', {
            //   me: response.data.user, 
            //   profile: response.data.profile
            // });

            // try {
            //   this.state.me.me.settings.email_addresses = this.state.me.me.settings.email_addresses.split(",");
            // }
            // catch(e) {}

            // try {
            //   this.state.me.me.settings.sms_numbers = this.state.me.me.settings.sms_numbers.split(",");
            // }
            // catch(e) {}


            // try {
            //   if (router.history.current.name != 'billing') {
            //     if (this.state.me.me.company_type != "admin") {
            //       if (!this.state.me.me.subscription) {
            //         router.push("/billing");
            //       }
            //       else {
            //         if (this.state.me.me.subscription.stripe_status != "active" && this.state.me.me.subscription.stripe_status != "trialing")
            //           router.push("/billing");
            //       }
            //     }
            //   }
            // }
            // catch (e) {}
            
            resolve()
            return;
          }
        } catch (error) {
          console.log(error)
          reject(error.response.data.message)
          return
        }
  
        reject()
  
      })
    },
    save(_, payload) {
      return new Promise(async (resolve, reject) => {

        try {
          let response = await axios.put(`${process.env.VUE_APP_API_ENDPOINT}/api/users/profile`, payload, {
            headers: {
              'Authorization': 'Bearer ' + (this.getters['auth/jwt'] || this.getters['auth/accessToken'] || localStorage.getItem('auth_token'))
            }
          })
          if (response.status == 200) {
            resolve(response.data)
            return;
          }
        } catch (error) {
          reject(error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Failed to update profile')
          return
        }

        reject()

      })
    },
    change_password(_, payload) {
      return new Promise(async (resolve, reject) => {

        try {
          let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/api/users/change-password`, payload, {
            headers: {
              'Authorization': 'Bearer ' + (this.getters['auth/jwt'] || this.getters['auth/accessToken'] || localStorage.getItem('auth_token'))
            }
          })
          if (response.status == 200) {
            resolve()
            return;
          }
        } catch (error) {
          reject(error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Failed to change password')
          return
        }

        reject()

      })
    },
    createSubscription(_, payload) {
      return new Promise(async (resolve, reject) => {

        try {
          let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/stripe/create`, payload, {
            headers: {
              'Authorization': 'Bearer ' + (this.getters['auth/jwt'] || this.getters['auth/accessToken'] || localStorage.getItem('auth_token'))
            }
          })
          if (response.status == 200) {
            resolve()
            return;
          }
        } catch (error) {
          reject(error.response.data.message)
          return
        }

        reject()

      })
    },
    changeSubscription(_, payload) {
      return new Promise(async (resolve, reject) => {

        try {
          let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/stripe/change`, payload, {
            headers: {
              'Authorization': 'Bearer ' + (this.getters['auth/jwt'] || this.getters['auth/accessToken'] || localStorage.getItem('auth_token'))
            }
          })
          if (response.status == 200) {
            resolve()
            return;
          }
        } catch (error) {
          reject(error.response.data.message)
          return
        }

        reject()

      })
    },
    cancelSubscription(_, payload) {
      return new Promise(async (resolve, reject) => {

        try {
          let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/stripe/cancel`, payload, {
            headers: {
              'Authorization': 'Bearer ' + (this.getters['auth/jwt'] || this.getters['auth/accessToken'] || localStorage.getItem('auth_token'))
            }
          })
          if (response.status == 200) {
            resolve()
            return;
          }
        } catch (error) {
          reject(error.response.data.message)
          return
        }

        reject()

      })
    }
  }

}